import { Link } from 'react-router-dom'
const ColumnLink = ({ to, text }) => {   
    return (

        <Link className="text-decoration-none"
            style={{ color: 'var(--mainText)' }} to={to} target="_blank" rel="noopener noreferrer" >{text}</Link>

    )
}
export default ColumnLink
